<template>
  <v-dialog max-width="500" v-model="opened">
    <v-card>
      <v-card-title>
        {{ $t('deleteModal.warning') }}
        <v-spacer />
        <v-btn @click="closeModal()" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider />

      <v-card-text class="pt-5 text-body-1">
        {{ $t('deleteModal.warningMessage', { entityName: name }) }}
      </v-card-text>

      <v-divider />

      <v-card-actions class="d-flex justify-end pa-5">
        <v-btn
          elevation="0"
          class="mr-5"
          @click="closeModal()"
          :disabled="loading"
          text
        >
          {{ $t('deleteModal.buttons.cancel') }}
        </v-btn>

        <v-btn
          @click="handleDelete()"
          :loading="loading"
          elevation="0"
          color="error"
        >
          {{ $t('deleteModal.buttons.delete') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import store from '@/store'

export default {
  name: 'DeleteModal',

  props: {
    toDelete: {
      type: String,
      required: true,
    },

    callback: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      id: null,
      name: null,
      opened: false,
      loading: false,
    }
  },

  methods: {
    openModal(id, name) {
      this.id = id
      this.name = name
      this.opened = true
    },

    closeModal() {
      this.opened = false
      this.loading = false
    },

    handleDelete() {
      this.loading = true
      store
        .dispatch(this.toDelete, this.id)
        .then(() => (this.opened = false))
        .then(() => this.callback())
        .finally(() => (this.loading = false))
    },
  },
}
</script>
